import { render, staticRenderFns } from "./MedSearchButton.vue?vue&type=template&id=7a064018&scoped=true&"
import script from "./MedSearchButton.vue?vue&type=script&lang=js&"
export * from "./MedSearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a064018",
  null
  
)

export default component.exports